import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import useResponsive from '@features/responsive/hooks/useResponsive';
import ConfiguratorSkeletonStyle from '@components/ConfiguratorSkeleton/ConfiguratorSkeleton.style';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import Heading from '@components/Heading/Heading';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  productName: string;
  productImage?: string;
  productPrice: string;
};
const ConfiguratorSkeleton = ({
  productName,
  productImage = undefined,
  productPrice
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const [imgLoaded, setImgLoaded] = useState(false);
  const {
    isWiderThanTablet
  } = useResponsive();
  return <div sx={ConfiguratorSkeletonStyle.wraper}>
      <div sx={ConfiguratorSkeletonStyle.container}>
        <div sx={ConfiguratorSkeletonStyle.productNameMobile}>
          <Heading h={1}>{productName}</Heading>
        </div>
        <div sx={ConfiguratorSkeletonStyle.imageContainer}>
          <div sx={ConfiguratorSkeletonStyle.image}>
            {!imgLoaded && <div sx={ConfiguratorSkeletonStyle.imageSkeletonContainer}>
                <Skeleton count={1} sx={ConfiguratorSkeletonStyle.imageSkeleton} enableAnimation />
              </div>}
            {productImage && <ResponsiveImage sx={ConfiguratorSkeletonStyle.imageLoader(imgLoaded)} image={productImage} alt={productName} width={450} height={450} onLoad={() => {
            setImgLoaded(true);
          }} objectFit="contain" />}
          </div>
          <div sx={ConfiguratorSkeletonStyle.carousel}>
            <Icon icon="ChevronLeft" size="31px" />
            <Skeleton count={isWiderThanTablet ? 7 : 5} width={131} height={60} borderRadius={0} inline />
            <Icon icon="ChevronRight" size="31px" />
          </div>
        </div>
        <div sx={ConfiguratorSkeletonStyle.configContainer}>
          <div>
            <div sx={ConfiguratorSkeletonStyle.productName}>
              <Heading h={1}>{productName}</Heading>
            </div>
            <div sx={ConfiguratorSkeletonStyle.configDescriptionSkeleton}>
              <Skeleton count={1} width={392} height={20} borderRadius={0} sx={ConfiguratorSkeletonStyle.configSkeleton} />
            </div>
            <Skeleton count={1} width={597} height={38} borderRadius={0} sx={ConfiguratorSkeletonStyle.configSkeleton} />
            <div sx={ConfiguratorSkeletonStyle.configSection}>
              <Skeleton count={5} width={110} height={50} inline borderRadius={0} sx={ConfiguratorSkeletonStyle.configSkeletonBoxes} />
            </div>
          </div>
          <div>
            <div sx={ConfiguratorSkeletonStyle.priceSkeleton}>
              <Skeleton count={1} width={597} height={38} borderRadius={0} sx={ConfiguratorSkeletonStyle.configSkeleton} />
            </div>
            <div sx={ConfiguratorSkeletonStyle.priceSection}>
              <div sx={ConfiguratorSkeletonStyle.price}>
                <p>{productPrice}</p>
              </div>
              <div sx={ConfiguratorSkeletonStyle.addToCart}>
                <Button variant="default" size="big" variantColor="lightGrey" disabled fullWidth>
                  {t('add_to_cart')}
                  <Icon icon="EcCart" size="24px" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ConfiguratorSkeleton;